export class OkCoinDepositAddressDto {
  address: string;
  tag: string;
  payment_id: string;
  memo: string;
  currency: string;
  to: string;
  chain: string;
  contract_address: string;
  selected: string;
}
